import { Component, OnInit } from '@angular/core';
import { ColaboradoresService } from '../../../services/colaboradores-service';
import { DialogsService } from '../../../services/dialogs-service';
import { NavigationService } from '../../../services/navigation-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ENTITY_TYPE_COLABORADOR } from '../../common/activity-list/activity-list.component';
import {PATH_ABM} from '../../../navigation/navigation.module';
import { PermisosService, PERM_ACCIONES_ID } from '../../../services/permisos-service';

@Component({
  selector: 'app-colaborador-detail',
  templateUrl: './colaborador-detail.component.html',
  styleUrls: ['./colaborador-detail.component.scss']
})
export class ColaboradorDetailComponent implements OnInit {

  private colaborador;
  private colaboradorId;
  private actividad = [];

  estadisticasConsignas = 0;
  estadisticasLogros = 0;
  estadisticasPuntos = 0;

  actividadPage: number = 0;
  lastActividadPage: number;

  ENTITY_TYPE_COLABORADOR = ENTITY_TYPE_COLABORADOR;

  private dataValid: boolean = true;

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  constructor(private route: ActivatedRoute,
              private colaboradoresService: ColaboradoresService,
              private location: Location,
              private dialogsService: DialogsService,
              private router: Router,
              private navService: NavigationService,
              private permisosService: PermisosService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.colaboradorId = this.route.snapshot.params['id'];
      this.loadData();
    });
  }

  loadData() {
    this.colaboradoresService.getColaborador(this.colaboradorId)
        .subscribe(value => {
          this.colaborador = value;
          if (!this.colaborador) {
            this.dataValid = false;
            return;
          }
        }, err => this.dataValid = false);

    this.getActividad();

    // this.getEstadisticas();
  }

  getActividad() {
    // si se busca la misma pagina dos veces se replican los resultados, no buscar a menos que sean paginas distintas
    // la pagina a buscar cambia al llegar al fondo al hacer scroll, solo entonces refrescar actividades
    if (this.lastActividadPage !== this.actividadPage) {
      this.lastActividadPage = this.actividadPage;

      this.colaboradoresService.getActividad(this.colaboradorId, this.actividadPage)
        .subscribe(value => {
          this.actividad = [...this.actividad, ...value.ResponseData.Result];
        });
    }
  }

  navigateBack() {
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_ABM);
    }
  }

  showNewConsignaDialog(){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', this.colaborador, null);
  }

  // getEstadisticas(){
  //   this.colaboradoresService.getEstadisticasColaborador(this.colaboradorId)
  //     .subscribe(data => {
  //       let { ResponseData } = data;
  //       this.estadisticasConsignas = ResponseData.ConsignasCantidad;
  //       this.estadisticasLogros = ResponseData.LogrosPorcentaje;
  //       this.estadisticasPuntos = ResponseData.Puntos;
  //     });
  // }

  editColaborador(){
    this.dialogsService.showNewColaboradorDialog(
        this.colaborador
      ).subscribe( () => {
          this.loadData();
      });
  }

  onBottomReached(reached: boolean) {
    this.actividadPage++;
    this.getActividad();
  }

  permisoAutorizado(accionId) {
    return this.permisosService.permisoAutorizado(accionId);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/colaborador-detail/colaborador-detail.component.ts